import { useEffect, useRef } from 'react';
import request from '../../../../../lib/request';

const Menu = ({
  dialogRef,
  closeDialog,
  selectedId,
  getWorkoutTracker,
  openEditDialog,
}) => {
  const bottomRef = useRef(null);

  useEffect(() => {
    const clickOutsideDialog = (e) => {
      if (
        dialogRef.current.contains(e.target) &&
        !bottomRef.current.contains(e.target)
      ) {
        closeDialog();
      }
    };

    document.addEventListener('click', clickOutsideDialog);

    return () => {
      document.removeEventListener('click', clickOutsideDialog);
    };
  }, []);

  const deleteWorkoutTracker = async (id) => {
    try {
      if (
        window.confirm('Are you sure you want to delete this workout record?')
      ) {
        await request.delete(`/workout/record/${id}`);
        await getWorkoutTracker();
        closeDialog();
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <dialog
      ref={dialogRef}
      className='w-full h-full max-w-lg max-h-full bg-transparent'
      onCancel={closeDialog}
    >
      <div
        ref={bottomRef}
        className={`bg-secondary fixed bottom-0 w-full max-w-lg rounded-t-3xl px-3 py-6 flex flex-col`}
      >
        <div className='text-white space-y-4'>
          <button
            onClick={() => deleteWorkoutTracker(selectedId)}
            className='flex items-center justify-center border border-red-600 bg-red-600/20 w-full rounded-full py-2'
          >
            Delete workout record
          </button>
          <button
            onClick={openEditDialog}
            className='flex items-center justify-center border border-accent bg-accent/20 w-full rounded-full py-2'
          >
            Edit workout record
          </button>
        </div>
      </div>
    </dialog>
  );
};

export default Menu;
